var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-settlement-software"},[_c('h2',[_vm._v("工程结算软件")]),_vm._v(" "),_c('p',[_vm._v("这里是工程结算软件页面的内容")])])
}]

export { render, staticRenderFns }